module.exports = __webpack_public_path__ + "static/media/1.22.a9db8a62.png";